import { Devices } from "../../../../styles";
import styled from "styled-components";

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  @media ${Devices.tablet} {
    width: auto;
  }
`;

export default Container;
